<style lang="less">
@import "../../../styles/common.less";
</style>
<template>
  <div class="consultaion">
    <div class="list-left" style="position:relative">
      <Tabs @on-click="selectTab">
        <Tab-pane :label="item.name" :key="item.id" v-for="item in tabsList">
          <ul class="list-card" v-for="(item,index) in cardLists"  @click="updateNum(item.id)"> 
            <li class="list-card-left"><img :src="item.image?item.image + '?x-image-process=image/resize,m_fixed,w_150,h_109' :defalutImg" :alt="item.title"></li>
            <li class="list-card-right">
              <p class="p16">{{item.title}}</p>
              <p class="p14">{{item.description}}</p>
              <p class="p12">
                <span>{{item.createDate}}</span>
                <span style="float:right">浏览量：{{item.hits}}</span>
              </p>
            </li>
          </ul>
        </Tab-pane>
      </Tabs>
      <div class="commont-page" style="position:absolute;bottom:10px;left:50%;transform:translate(-50%, -50%)">
        <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
      </div>     
    </div>   
    <div class="list-right">
      <div class="list-right-top">
        <div class="list-title" v-if="showSpan">
            <span style="margin-left:20px">在线疑问解答</span>
            <span class="list-btn" @click="handleSapn">检索</span>
        </div>
        <div v-else style="width:424px;height:62px;border-bottom:1px solid #eee;overflow:hidden">
          <div class="list-search">
            <input v-model="questionVal" placeholder="请输入您想了解的问题" class="select-input" />
            <span class="btn-span" @click="askQuestion">检索</span>
          </div>
        </div>        
        <ul class="list-right-ul">
          <li v-for="(item,index) in messageList" :key="index" style="cursor:pointer" @click="contentInfoModel(item.id)"><span>{{item.content}}</span></li>        
        </ul>
        <div class="list-right-more">
          <span style="cursor:pointer" @click="pushRouter">更多</span>
          <img src="@/assets/more-tip.png" alt='版权登记'/>
        </div>
      </div>
      <div class="list-right-bottom">
        <div class="layer">
          <img src="@/assets/message-ques.png" alt='版权登记'/>
          <button @click="linkPerson">法律问题咨询</button>
        </div>
        <div class="layer">
          <img src="@/assets/message-phone.png" alt='版权登记'/>
          <button @click="linkPerson">联系客服</button>
        </div>
      </div>
    </div>
    <!-- 问题详情 -->
    <generalframe @fatherMethod="fatherMethod" mywidth='631' myheight='420' v-show="showDialog" :tishihide='false'  maintitle="在线疑问解答" ref="mychild">
        <div style="text-align:left;padding:20px;color:#333">{{reContent}}</div>
    </generalframe>
  </div>
</template>

<script>
import { _getColumn,_getValidByPage,_updatePageviews,_getValidPage } from "@/api/consultation";
import generalframe from '../vip/lawcomponent/generalframe.vue';
export default {
  metaInfo: {
      title: '版权信息列表|版权服务专家|前海版权公共服务平台',
      meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,前海版权公共服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
      },{
          name: 'Description',
          content: '版权信息列表,人人都是创作者，人人都是版权人。前海版权公共服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
      }]
  },
  name: "consultaionList",
  components:{
      generalframe
  },
  data(){
    return{
      tabsList:[],
      pageNumber:1,
      pageSize:7,
      pages:0,
      total:0,
      sort:"",
      order:"desc",
      categoryId:"",
      title:"",
      cardLists:[],
      messageList:[],
      questionVal:"",
      showSpan:true,
      content:"",
      showDialog:!1,
      reContent:"",
      defalutImg:require('@/assets/news1.png'),
    }
  },
  methods: { 
    //获取顶部菜单   
    getColumn() {
      _getColumn().then(res => {
        if(res.code==200){
          const topMenu = res.result;       
          topMenu.length>0&&topMenu.map((item)=>{
            if(item.id==2){
              this.tabsList = item.childs;            
              this.categoryId=item.childs[0].id;
            }
          });
          this.getValidByPage();
        }
      });
    },
    //获取当前选中菜单
    selectTab(key){
      switch (key) {
        case 0:
          this.categoryId=this.tabsList[0].id;
          this.getValidByPage()
          break;
        case 1:
          this.categoryId=this.tabsList[1].id;
          this.getValidByPage()
          break;
        case 2:
          this.categoryId=this.tabsList[2].id;
          this.getValidByPage()
          break;
        case 3:
          this.categoryId=this.tabsList[3].id;
          this.getValidByPage()
          break;
        default:
          break;
      }
    },
    //分页查询有效文章
    getValidByPage(){
      const data ={
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        sort:"create_date",
        order:"desc",
        categoryId:this.categoryId,
        title:""
      }
      _getValidByPage(data).then(res => {
        if(res.code==200){
          this.cardLists= res.result.records;
          this.total = Number(res.result.total);
          this.pages = Number(res.result.pages);
        }
      });
    },
    //更新浏览量
    updateNum(value){
      _updatePageviews({id:value}).then(res=>{
        if(res.code==200){
          console.log("浏览量+1")
        }
      })
      let tempUrl = '/consultation-info/'+value
      window.open(tempUrl+".html",'_blank')
      // this.$router.push({path: '/consultation-info', query: {id:value }});
    },
    //分页查询有效留言
    getValidPage(){
      const value ={
        pageNumber:1,
        pageSize:8,
        sort:"create_date",
        order:"desc",
        registerId:"",
        content:this.content,
        phone:""
      }
      _getValidPage(value).then(res => {
        if(res.code==200){
          this.messageList = res.result.records
        }
      });
    },
    //分页
    changepage(index){
        this.pageNumber = index
        this.getValidByPage()
    },
    //提问
    handleSapn(){
      this.showSpan=false;     
    },
    askQuestion(){
      this.content=this.questionVal;
      this.getValidPage()
    },
    //更多
    pushRouter(){
      this.$router.push({name:'searchQuestion'})
    },
    //问题详情
    fatherMethod() {
      this.showDialog = !1;          
    },
    contentInfoModel(val){
      this.showDialog = !0;
      this.getRequest("/cmsGuestbook/get/" + val).then(res => {
        this.reContent=res.result.reContent
      });
    },
    //联系客服
    linkPerson(){
      if(typeof(_MEIQIA)!='undefined'){
        _MEIQIA('showPanel');
      }else{
        console.log("美洽开始初始化"+new Date().getTime());
        (function(m, ei, q, i, a, j, s) {
          m[i] = m[i] || function() {
            (m[i].a = m[i].a || []).push(arguments)
          };
          j = ei.createElement(q),
                  s = ei.getElementsByTagName(q)[0];
          j.async = false;
          j.charset = 'UTF-8';
          j.src = '//static.meiqia.com/dist/meiqia.js';
          s.parentNode.insertBefore(j, s);
        })(window, document, 'script', '_MEIQIA');
        _MEIQIA('manualInit');
        _MEIQIA('entId', '43951');
        //隐藏美洽客服按钮
        _MEIQIA('withoutBtn');
        // 初始化成功时的回调
        _MEIQIA('allSet', this.consultationMeiqiaCallBack);
        //创建美洽
        _MEIQIA('init');
        console.log("美洽初始化结束"+new Date().getTime());
        _MEIQIA('showPanel');
      }
    },
    consultationMeiqiaCallBack() {
      console.log("初始化回调成功"+new Date().getTime());
    }
  },
  mounted() {
    this.getColumn();
    this.getValidPage();
  },
};
</script>

<style scoped lang="less">
.consultaion{
  width: 1334px;
  min-height: 650px;
  display: flex;
  justify-content:space-between;
  margin:20px auto 50px;
  .list-left{
    width:890px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
    border-radius:2px;
    padding-bottom: 50px;
    /deep/ .ivu-tabs-bar{
      border-bottom: 1px solid #eee;
      margin-bottom:27px;
    }
    /deep/ .ivu-tabs-nav-container{
      height:62px;
      line-height: 62px;
      font-size: 16px;
      color:rgba(51,51,51,1);
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab{
      width: 222px;
      text-align: center;
      padding:0px;
      margin-right: 0px;
      color:rgba(153,153,153,1);
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
      color:rgba(51,51,51,1);
    }
    /deep/ .ivu-tabs-ink-bar{
      background-color:transparent;
    }
    .list-card{
      overflow: hidden;
      height: 129px;
      border-bottom: 1px solid #EEEEEE;
      margin-bottom: 20px;
      cursor: pointer;
      li{
        float: left;
        list-style: none;
      }
      .list-card-left img{
        width: 150px;
        height: 109px;
        margin:0 20px;
      }      
      .list-card-right{
        width: 680px;
        height: 120px;
        p{              
          line-height:22px;
        }
        .p16{
          font-size:16px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;    
        }
        .p14{
          height: 44px;
          font-size:14px;
          color:rgba(102,102,102,1);
          margin:8px 0px 12px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          cursor: pointer;
        }
        .p12{
          font-size:12px;
          color:rgba(153,153,153,1);
        }
      }
    }
  }
  .list-right{
    width:424px;
    height:835px;
    .list-right-top{
      width:424px;
      height:613px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
      border-radius:2px;
      margin-bottom: 20px;
      .list-title{
        width:424px;
        height:62px;
        line-height: 62px;
        background:rgba(255,255,255,1);
        border-radius:2px 2px 0px 0px;
        font-size:16px;
        color:rgba(51,51,51,1);
        border-bottom: 1px solid #EEEEEE;
      }
      .list-btn{
        display: inline-block;
        float: right;
        width:60px;
        height:40px;
        line-height: 40px;
        background:rgba(246,246,246,1);
        border-radius:20px;
        font-size:14px;
        font-weight:400;
        text-align: center;
        color:rgba(102,102,102,1);
        margin:11px 20px;
        cursor: pointer;
      }
      .list-right-ul{
        overflow: hidden;
        height: 489px;
        li{
          list-style: none;
          height: 60px;
          width: 404px;
          line-height: 60px;
          font-size:14px;
          color:rgba(102,102,102,1);
          margin-left: 20px;        
          border-bottom: 1px solid #EEEEEE;
          span{
            display: inline-block;
            width:394px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .list-right-more{
        height: 62px;
        line-height: 62px;
        font-size:14px;
        font-weight:400;
        color:rgba(102,102,102,1);
        text-align: right;
        img{
          width:14px;
          height: 10px;
          vertical-align: middle;
          margin:0 20px 0 5px;
          cursor: pointer;
        }
      }
    }
    .list-right-bottom{
      width: 424px;
      height: 202px;
      display: flex;
      justify-content: space-between;
      .layer{
        width:207px;
        height:202px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:2px;
        text-align: center;
        overflow: hidden;
        img{
          width:104px;
          height: 94px;
          margin:22px 0px 38px;
        }
        button{
          width:124px;
          height:33px;
          line-height: 33px;
          background:rgba(255,216,0,1);
          border-radius:2px;
          border:0px;
          outline: none;
          font-size:12px;
          color:rgba(51,51,51,1);
          cursor: pointer;
        }
      }
    }
  }
}
.list-search{
  width:384px;
  height:40px;
  background:rgba(246,246,246,1);
  border-radius:20px;
  margin:11px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .select-input{
    border:0px;
    background:transparent;
    outline: none;
    width: 260px;
    height: 40px;
    margin-left:26px;
  }
  .btn-span{
    display: inline-block;
    width:68px;
    height:30px;
    background:rgba(255,216,0,1);
    border-radius:20px;
    margin-right: 5px;
    text-align: center;
    line-height: 30px;
    color:#333;
    cursor: pointer;
  }
}
</style>
